{
  $(window).on('load', function() {
    const docH = $(document).innerHeight();
    const winH = $(window).innerHeight();
    const pageBtm = docH - winH; //ドキュメントの高さ - ウィンドウの高さ
    $(window).on("scroll", function () {
          if ($(this).scrollTop() > 100 && $(this).scrollTop() < pageBtm - 100) {
            $(".c-fade").addClass('js-show');
          } else {
            $(".c-fade").removeClass('js-show');
          }
        });
      });
}

